import { useSubmitFeedbackMutation } from '@pages/api/submit-feedback';
import { useCallback, useState } from 'react';
import { FeedbackSteps } from '../constants/feedback-constants';
import { isLowScore } from '../utils/feedback-utils';

const NO_DETAILS = { reasons: [], answers: [], comment: '' };

// Good score: rating → capture → thank you.
// Bad score:  rating → low-score screen (enabled reason chips / follow-ups +
// the always-present comment) → capture → thank you.
export const useFeedbackFlow = ({ form, locale }) => {
  const [step, setStep] = useState(FeedbackSteps.RATING);
  const [score, setScore] = useState(null);
  const { mutate: submitFeedback, isPending: isSubmitting } = useSubmitFeedbackMutation();

  const submit = useCallback(({ reasons, answers, comment }) => submitFeedback({
    captureUrl: form.captureUrl,
    locale,
    score,
    selectedReasonSlots: reasons,
    reasons: form.lowScore.reasonsEnabled ? form.lowScore.reasons : [],
    reasonSlotCount: form.lowScore.reasonsEnabled ? form.lowScore.reasonSlotCount : 0,
    answers,
    questions: form.lowScore.questionsEnabled ? form.lowScore.questions : [],
    questionSlotCount: form.lowScore.questionsEnabled ? form.lowScore.questionSlotCount : 0,
    comment,
  }, {
    // Failures are shown by the http interceptor with the BE message.
    onSuccess: () => setStep(FeedbackSteps.THANK_YOU),
  }), [submitFeedback, form, locale, score]);

  const submitRating = useCallback(() => {
    if (isLowScore(score, form.lowScoreThreshold)) setStep(FeedbackSteps.LOW_SCORE);
    else submit(NO_DETAILS);
  }, [score, form, submit]);

  return {
    step,
    score,
    isSubmitting,
    setScore,
    submitRating,
    submitLowScore: submit,
  };
};
